module.exports = __webpack_public_path__ + "img/fxwlCode.f9636735.jpg";